import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  List,
  ListItem,
  Grid,
  IconButton,
  Divider,
} from '@mui/material';
import SouthIcon from '@mui/icons-material/South';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImageReveal from '../../../../Components/ImageReveal';
import { Services } from '../../../../assets';
import SmoothWaveText from '../../../../Components/SmoothWaveText';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Mentoring from './MentoringTabs';
import MobaileMentoring from './MobaileMentoring';
import { Helmet } from 'react-helmet-async';
import Mentoring2 from './Mentoring2';
import Mentoring3 from './Mentoring3';
import Steps2 from './MentoringFinal';
import MentoringFinal from './MentoringFinal';
import MentoringSlider from './MentoringSlider';
import LatestSteps from './LatestSteps';
import SalesCoachingCards from './SalesCoachingCards';
import OldStepsCode from './OldStepsCode';
// import LuxuryHero from '../../../Dashboard/LuxuryHero';
// import Portfolio2 from '../../../Dashboard/Portfolio2';

gsap.registerPlugin(ScrollToPlugin);

const MentoringServices = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    contentRefs.current.forEach((ref, index) => {
      if (ref) {
        const isActive = activeIndex === index;
        const height = ref.scrollHeight;

        gsap.to(ref, {
          height: isActive ? height : 0,
          duration: 0.4,
          ease: 'power2.inOut',
          onComplete: () => {
            if (isActive && ref) ref.style.height = 'auto';
          },
        });
      }
    });
  }, [activeIndex]);

  useEffect(() => {
    const bounceAnimation = gsap.to('.south-icon', {
      y: '-20px',
      repeat: -1,
      yoyo: true,
      duration: 0.8,
      ease: 'power1.inOut',
    });

    return () => {
      bounceAnimation.kill();
    };
  }, []);

  const handleScroll = (targetId: string) => {
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      gsap.to(window, {
        scrollTo: {
          y: targetElement,
          offsetY: 100, // Optional offset for spacing
        },
        duration: 1,
        ease: 'power2.inOut',
      });
    } else {
      console.error(`Element with ID ${targetId} not found.`);
    }
  };

  return (
    <>
      <Helmet>
        <title>Best Real Estate Mentor in Hyderabad | Rajiv Williams</title>
        <meta
          name="description"
          content="Connect with the best business mentor in Hyderabad. Receive expert coaching to enhance your leadership skills, grow your business, and achieve success."
        />
        <meta
          name="keywords"
          content="best real estate mentor in hyderabad, best business mentor in hyderabad, real estate mentor in hyderabad, best real estate broker, best real estate broker in Hyderabad, Top Property Consultant in Hyderabad, Best Property Advisor in Hyderabad, Best Realtor in Hyderabad, top real estate consultants in hyderabad, top real estate companies hyderabad, top real estate companies in hyderabad, top commercial real estate agents, best real estate company in hyderabad, top real estate agents, best real estate agents, top commercial real estate companies, good real estate agent"
        />
        <link
          rel="canonical"
          href="https://rajivwilliams.com/real-estate-mentor"
        />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Best Real Estate Mentor in Hyderabad | Rajiv Williams"
        />
        <meta
          property="og:description"
          content="Connect with the best business mentor in Hyderabad. Receive expert coaching to enhance your leadership skills, grow your business, and achieve success."
        />
        <meta
          property="og:url"
          content="https://rajivwilliams.com/real-estate-mentor"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://dprstorage.b-cdn.net/RW/serv1.png"
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best Real Estate Mentor in Hyderabad | Rajiv Williams"
        />
        <meta
          name="twitter:description"
          content="Connect with the best business mentor in Hyderabad. Receive expert coaching to enhance your leadership skills, grow your business, and achieve success."
        />
        <meta
          name="twitter:image"
          content="https://dprstorage.b-cdn.net/RW/serv1.png"
        />
      </Helmet>

      <Box sx={{ color: '#000',  }}>
        <Box>
              <OldStepsCode/>
        </Box>
        <Box sx={{ 
          // mb: 6 ,
          background:'radial-gradient(1200px 600px at 10% 20%, rgba(15, 99, 165, 2.18), #1175c100 60%), radial-gradient(1000px 500px at 90% 80%, rgba(15, 99, 165, 0.12), transparent 60%), linear-gradient(180deg, #4b5b6b 0%, #1e5799 45%, #638cb7 100%)'
          // 'radial-gradient(1200px 600px at 10% 20%, rgba(15, 99, 165, 2.18), #1175c100 60%), radial-gradient(1000px 500px at 90% 80%, rgba(15, 99, 165, 0.12), transparent 60%), linear-gradient(180deg, #f8fafc 0%, #1e5799 45%, #889fb7 100%)'
        }}>
          <Container maxWidth="lg">
            {/* <SmoothWaveText
              variant="h3"
              sx={{
                fontSize: { xs: 42, md: 72 },
                fontWeight: 700,
                color: 'primary.main',
                mt:3,
                
              }}
            >
              Coaching
            </SmoothWaveText> */}
            {/* <Portfolio2 /> */}
            <MentoringSlider />
            
            <Box sx={{ position: 'relative', textAlign: 'start' }}>
              {/* <Box
                component="a"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#text');
                }}
                sx={{
                  display: 'flex',
                  width: 60,
                  height: 60,
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#171818',
                  border: '10px solid #171818',
                  borderRadius: '50%',
                  position: 'absolute',
                  top: { xs: -57, md: -15 },
                  left: '50%',
                  transform: 'translateX(-50%)',
                  transition: 'all .3s ease',
                  zIndex: 2,
                  '&:hover': {
                    backgroundColor: '#0f63a5',
                  },
                  // mb:{xs:8,lg:0}
                }}
              >
                <SouthIcon
                  className="south-icon"
                  sx={{
                    width: 30,
                    height: 30,
                    transition: 'all .3s ease',
                    color: '#fff',
                  }}
                />
              </Box> */}

              {/* <Box>
                <ImageReveal
                  src="https://dprstorage.b-cdn.net/RW/serv1.png"
                  alt="Best Business Mentor in Hyderabad"
                  width="100%"
                  height="auto"
                  threshold={0.8}
                  scaleDuration={3}
                  sx={{
                    borderRadius: '40px',
                    display: { xs: 'none', md: 'block' },
                  }}
                />
              </Box> */}
              {/* <Box sx={{ mt: 10 }}>
                <ImageReveal
                  src="https://dprstorage.b-cdn.net/RW/servm1.png"
                  alt="Best Business Mentor in Hyderabad"
                  width="100%"
                  height="auto"
                  threshold={0.8}
                  scaleDuration={3}
                  sx={{ borderRadius: '40px', display: { xs: 'block', md: 'none' } }}
                />
              </Box> */}
            </Box>
          </Container>
        </Box>

        {/* <Container maxWidth="lg" sx={{ mt: 1,pb:2 }}>
          <SmoothWaveText
              variant="h4"
              sx={{ fontSize: 36, mb: 2, textAlign: 'start', fontWeight: 700 }}
            >
              Sales Coaching for Competitive Real Estate Markets
            </SmoothWaveText>
          <Box id="text" sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ textAlign: 'start' }}>
              We work with real estate professionals and builder sales teams who want control over their sales conversations, not just more activity
            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'start', mt: 2 }}>
              This coaching focuses on how deals actually move forward, from the first conversation to the final close, especially in premium and ultra-competitive markets.
            </Typography>
          </Box>

          <Box sx={{ mb: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, textAlign: 'start' }}>
             What This Coaching Helps You Fix

            </Typography>
            <List sx={{ listStyle: 'none', pl: 0 }}>
              {[
                'Strengthen how you communicate with buyers without sounding pushy',
                'Build a healthier and more predictable sales pipeline',
                'Improve follow-ups so momentum doesn’t drop after site visits',
                'Handle pricing, trust, and comparison objections with clarity',
                'Develop the mindset and confidence required to sell consistently',

              ].map((text, i) => (
                <ListItem
                  key={i}
                  sx={{
                    position: 'relative',
                    pl: 3,
                    mb: 1,
                    '&::before': {
                      content: '""',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#0f63a5',
                      position: 'absolute',
                      left: 0,
                      top: 12,
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ textAlign: 'start' }}>
                    {text}
                  </Typography>
                </ListItem>
              ))}
            </List>

            <Typography variant="body2" sx={{ textAlign: 'start' }}>
              
            </Typography>
          </Box>
          <Box sx={{ mb: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, textAlign: 'start' }}>
            Why This Works

            </Typography>
            <List sx={{ listStyle: 'none', pl: 0 }}>
              {[
                'This is not theory-based training',
                'The work is built on real sales situations, proven frameworks, and practical psychology, so conversations feel natural, structured, and effective',
                

              ].map((text, i) => (
                <ListItem
                  key={i}
                  sx={{
                    position: 'relative',
                    pl: 3,
                    mb: 1,
                    '&::before': {
                      content: '""',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#0f63a5',
                      position: 'absolute',
                      left: 0,
                      top: 12,
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ textAlign: 'start' }}>
                    {text}
                  </Typography>
                </ListItem>
              ))}
            </List>

            <Typography variant="body2" sx={{ textAlign: 'start' }}>
              
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, textAlign: 'start' }}>
            What You Gain

            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'start' }}>
              You walk away with:
            </Typography>
            <List sx={{ listStyle: 'none', pl: 0 }}>
              {[
                'Clear sales structure and repeatable conversations',
                "Stronger negotiation control",
                'Better buyer confidence and faster decisions',
                'A refined personal brand and professional presence'
               

              ].map((text, i) => (
                <ListItem
                  key={i}
                  sx={{
                    position: 'relative',
                    pl: 3,
                    mb: 1,
                    '&::before': {
                      content: '""',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#0f63a5',
                      position: 'absolute',
                      left: 0,
                      top: 12,
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ textAlign: 'start' }}>
                    {text}
                  </Typography>
                </ListItem>
              ))}
            </List>

            <Typography variant="body2" sx={{ textAlign: 'start' }}>
              Most importantly, you stop guessing, and start leading conversations.

            </Typography>
          </Box>

          
        </Container> */}

        <Box>
          <SalesCoachingCards/>
          {/* <MentoringSlider /> */}
          {/* <MentoringFinal /> */}
          {/* <LuxuryHero/> */}
       
        </Box>
      </Box>
    </>
  );
};

export default MentoringServices;
